export default {
  label: {
    tooltip: {
      info: 'Filtro do componente',
    },
    icon: {
      key: 'F',
    },
  },
};
